import AppContext from "PFApp/app_context";
import { Button } from "PFComponents/button";
import Card from "PFComponents/card/card";
import { FileUpload } from "PFComponents/file_upload";
import { LoadingDots } from "PFComponents/loading_dots";
import ProfindaLogo from "PFComponents/profinda_logo";
import { usePusherEvent } from "PFCore/base/pusher";
import { useRemoveAccountLogo } from "PFCore/hooks/queries/accounts/use_remove_account_logo";
import { useErrorsGrowl } from "PFCore/hooks/use_errors_growl";
import { ApiRoute } from "PFCore/utilities/routes";
import { CURRENT_ACCOUNT_ACTIONS } from "PFReducers/current_account_reducer";
import React, { useCallback, useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./branding.less";

const Branding = () => {
  const { t } = useTranslation("branding");
  const {
    dispatch,
    store: { currentAccount, currentProfile, themeVars }
  } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const growlErrors = useErrorsGrowl();
  const { mutate: removeLogo } = useRemoveAccountLogo();

  const changeLogo = (payload) => {
    dispatch({
      type: CURRENT_ACCOUNT_ACTIONS.CURRENT_ACCOUNT_UPDATE_LOGO,
      payload
    });
    setLoading(false);
  };

  const inputRef = useRef();

  const handleChangeAccountLogo = useCallback(({ source, url, normal }) => {
    if (source !== "Account#logo") {
      return;
    }
    changeLogo({ full_url: url, thumbnail_url: normal.url });
  }, []);

  usePusherEvent(
    `private-profile-${currentProfile.id}`,
    "current_user:picture_processed",
    handleChangeAccountLogo
  );

  const handleError = (resp) => {
    growlErrors(resp, { display_all: true, version: "v2" });
    setLoading(false);
  };

  const resetLogo = () => {
    setLoading(true);
    removeLogo(
      { accountId: currentAccount.id },
      {
        onSuccess: () => changeLogo(null),
        onError: ({ responseJSON }) => handleError(responseJSON)
      }
    );
  };

  const colorMain = themeVars["--Palette-base"] || "inherit";
  const colorSecondary = themeVars["--Palette-base-light"] || "#000";
  const thumbnailUrl = currentAccount.customization.logo.thumbnail_url;
  const Logo = thumbnailUrl ? (
    <img src={thumbnailUrl} alt="" />
  ) : (
    <ProfindaLogo colorSecondary={colorSecondary} colorMain={colorMain} height={40} width={140} />
  );

  return (
    <div className={css.root}>
      <h1>{t("title")}</h1>
      <Card style={{ maxWidth: 800 }} bodyClassName={css.cardBody}>
        <p>{t("bestResultsNote")}</p>
        <small>{t("preview")}:</small>
        <div className={css.preview}>{loading ? <LoadingDots /> : Logo}</div>
        <div className={css.fileInputWrap}>
          <FileUpload
            inputRef={inputRef}
            url={ApiRoute(`/api/accounts/${currentAccount.id}/logo`)}
            name="logo"
            qaId="branding"
            handleChange={() => setLoading(true)}
            handleError={handleError}
            handleNetworkError={() => setLoading(false)}
          />
        </div>
        <div className={css.submitButtons}>
          <Button kind="primary" onClick={() => inputRef.current?.click()}>
            {t("changeLogo")}
          </Button>
          <Button kind="danger" onClick={resetLogo}>
            {t("setDefault")}
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default Branding;
